import { HiShieldCheck } from "react-icons/hi2";
import { Link } from "react-router-dom";
interface PropsData{
    isVerified:boolean;
}
const VerifiedBadge = (isVerified:PropsData) => {
  return (
    <Link
      to="#"
      className={
      isVerified
          ? "d-inline-flex align-items-center flex-nowrap px-2 py-1 border  rounded-pill border-success"
          : "d-inline-flex align-items-center flex-nowrap px-2 py-1 border  rounded-pill border-warning"
      }
      style={{ whiteSpace: "nowrap" }} 
    >
      <HiShieldCheck
        size={16}
        className="me-1 flex-shrink-0"
        color={isVerified ? "#008A05" : "#FF9D2C"}
      />

      <small
        className="fw-semibold font-10"
        style={{
          color: isVerified ? "#008A05" : "#FF9D2C",
          whiteSpace: "nowrap", // ✅ text never wraps
        }}
      >
        {isVerified ? "Verified" : "Un-Verified"}
      </small>
    </Link>
  );
};
export default VerifiedBadge;